import React from "react";
import { Link } from "react-router-dom";
import {
  FaRocket,
  FaCoins,
  FaHeadset,
  FaShieldAlt,
  FaUserCheck,
  FaArrowRight,
} from "react-icons/fa";

const QuickContact = () => {
  return (
    <>
      {/*===== CONTACT AREA STARTS =======*/}
      <div className="contact5-section-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 m-auto">
              <div className="contact-header-area text-center heading10">
                <h5>
                  <img src="assets/img/icons/logo-icons6.svg" alt="" />
                  Get in Touch
                </h5>
                <h2 className="text-anime-style-3">
                  Have Questions About our services or Partnership?
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="col-lg-5"
              data-aos="zoom-in"
              data-aos-duration={1200}
            >
              <div className="contact-info-area">
                <h3>Contact Info</h3>
                <p>
                  Whether you want to offer our services as a agent, or need API
                  integration for your business, our team is ready to assist
                  you.
                </p>
                <div className="space32" />
                <div className="contact-auhtor-box">
                  <div className="icons">
                    <img src="assets/img/icons/location2.svg" alt="" />
                  </div>
                  <div className="content">
                    <h4>Our Location</h4>
                    <a href="#">
                      PANMITRA ONLINE SERVICE PRIVATE <br /> LIMITED, Belagavi,
                      Karnataka - 590015, India
                    </a>
                  </div>
                </div>
                <div className="space40" />
                <div className="contact-auhtor-box">
                  <div className="icons">
                    <img src="assets/img/icons/phone2.svg" alt="" />
                  </div>
                  <div className="content">
                    <h4>Phone Number</h4>
                    <a href="tel:919632456111">+91 9632-456-111</a>
                  </div>
                </div>
                <div className="space40" />
                <div className="contact-auhtor-box">
                  <div className="icons">
                    <img src="assets/img/icons/email2.svg" alt="" />
                  </div>
                  <div className="content">
                    <h4>Email Address</h4>
                    <a href="mailto:panmitra121@gmail.com">
                      panmitra121@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-7"
              data-aos="zoom-in"
              data-aos-duration={1200}
            >
              <div className="contact-boxarea">
                <h3>Send Us a Message</h3>
                <p>
                  Interested in our PAN card services, utility bill payments, or
                  becoming a partner? Fill out the form and we'll get back to
                  you within 24 hours.
                </p>
                <form action="https://api.web3forms.com/submit" method="POST">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-area">
                        <input
                          type="text"
                          placeholder="First Name"
                          required=""
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-area">
                        <input
                          type="text"
                          placeholder="Last Name"
                          required=""
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-area">
                        <input
                          type="email"
                          placeholder="Email Address"
                          required=""
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-area">
                        <input
                          type="number"
                          placeholder="Phone Number"
                          required=""
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-area">
                        <textarea
                          placeholder="Your Message (e.g., become a agent, API access, partnership inquiry)"
                          required=""
                          defaultValue={""}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-area">
                        <button className="header-btn11">
                          Send Message
                          <span>
                            <i className="fa-solid fa-arrow-right" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== CONTACT AREA ENDS =======*/}
    </>
  );
};

export default QuickContact;
